import { useMutation } from "@apollo/client";

import { DeletePaymentMethodDocument } from "../../__generated__/graphql";

export function useDeletePaymentMethod() {
  return useMutation(DeletePaymentMethodDocument);
}
